import React from 'react'
import Navbar from "../inc/Navbar";
import Slider from "../inc/Slider";
import Dulux from "../images/dulux.jpg";
import CatloguePhinolex from "../images/catlogue2.jpg";
import cotobathware from "../images/cotocatlogue.jpg";
import Kajriacatlogue from "../images/kajriacatlogue.jpg";
import Jaqure from "../images/u.jpg";
import Umamap from "../pages/Umamap";
import Jaquar from "../pages/Jaquar";
import Orient from "../pages/Orient";
import Somany from "../pages/Somany";
import Johnson from "../images/johnson.jpg";
import Orientbellcatlogue from "../images/orientbellcatlogue.jpg";
import Somanycatlogue from "../images/somanycatlogue.jpg";
import PdfJaquar from "../images/Grey Matt Color - Leaflet.pdf";
import PdfJohnson from "../images/Johnson.pdf";
import Pdffinoloex from "../images/finoloex.pdf";
import PdfCoto from "../images/Coto.pdf";
import SOMANYPDFH from "../images/SOMANYPDF.pdf";
import Popup from "./Popup";

import kajariavitronite2025 from "../images/Kajaria Vitronite 2025.pdf";
import Pdforientbellcatalogue from "../images/orientbellcatalogue.pdf";

import Pdfe from "../images/essco.pdf";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import {
  FacebookShareButton, WhatsappShareButton, WhatsappIcon,
  FacebookIcon, TwitterShareButton, EmailShareButton, EmailIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterIcon,
} from "react-share";
import "./Home.css";
import Kajaria from './Kajaria';
import Watertec from './Watertec';
import KajariaNouvella from './KajariaNouvella';


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import alexus from "../images/Alexus.jpg"
import bannet from "../images/Bannet.jpg";
import barndonpearl from "../images/Barndol.jpg";
import Lucasmarble from "../images/Lucas Marble.jpg";

import milangrey from "../images/Milan Grey.jpg"
import elorawhite from "../images/Elora White.jpg";
import brellastone from "../images/Brella Stone Marbel.jpg";
import Ordinagris from "../images/Ordina Gris.jpg"
import jaquarproduct from "../images/Jaquar Product.jpg"
import Kajariatiles from "../images/KAJARIA.jpg";
import johnsontiles from "../images/JHONSON Tiles.jpg";
import somanytiles from "../images/SOMANY.jpg";
import orintbelltiles from "../images/ORIENTBELL TILES.jpg";
import dulux from "../images/DULUX page.jpg";
import Jaquarpage from './Jaquarpage';



function Home() {
  return (
    <div>
      <Navbar />
      <br />

      <div className="album py-1">
        <div className="container">

          <div className="row">
            <h5> Uma Hardware - Karimpur, Natna</h5>
          </div>
        </div></div>
      <br />
      <br />
      <div className="album py-0">
        <div className="container">
          <Slider />
        </div>

      </div>
      <br />
      <div class="tilesshowroomkarimpur">
        <div className="album py-0">
          <div className="container">
            <marquee><h5 className='mt-3' style={{ color: "white" }}> Welcome to Uma Hardware – Your trusted hardware partner at Natna, Karimpur </h5></marquee>
          </div>
        </div>
      </div>
      <br />
      <div className="album py-0">
        <div className="container">
          <center>
            <h1 className='mb-0'><b><b style={{ color: "#001284ff" }}>Uma Hardware</b> Trusted Hardware Store in Karimpur</b></h1>
            <p><small>Uma Hardware offers a wide range of high-quality tiles, marbles, sanitary ware, plumbing, and hardware materials.</small></p>
          </center>
        </div>

      </div>

      <div className="album py-0">
        <div className="container">
          <div className="row">

            <div className="col-md-4">
              <h1 className='mb-0'><b>Our <b style={{ color: "#001284ff" }}>Products </b> </b></h1>
              <hr className='mb-2' />
            </div>
          </div>
        </div>

      </div>
      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-2">
              <div className="alert alert-primary shadow" role="alert">

                <img src={jaquarproduct} className="card-img-top" alt="jaquarproduct" />
                <div className="card-body">
                  <h5 className="card-title mt-2 mb-0"><b>Jaquar</b></h5>
                  <p className="card-text mb-2"><small>Best Jaquar products avaialbe</small></p>
                  <a style={{ color: "white" }} href="Jaquar" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                  </svg></a>
                </div>

              </div>
            </div>
            <div className="col-md-4 mt-2">
              <div className="alert alert-success" role="alert">

                <img src={Kajariatiles} className="card-img-top" alt="Kajariaritiles_Karimpur" />
                <div className="card-body">
                  <h5 className="card-title mt-2 mb-0">Kajaria</h5>
                  <p className="card-text mb-2">Best Kajaria products avaialbe

                  </p>
                  <a style={{ color: "white" }} href="KajariaNouvelle" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                  </svg></a>

                </div>
              </div>
            </div>
            <div className="col-md-4 mt-2">
              <div className="alert alert-info" role="alert">

                <img src={johnsontiles} className="card-img-top" alt="johnsontiles_karimpur" />
                <div className="card-body">
                  <h5 className="card-title mt-2 mb-0">Johnson Tiles</h5>
                  <p className="card-text mb-2">Best Johnson tiles products avaialbe

                  </p>
                  <a style={{ color: "white" }} href="Johnson" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                  </svg></a>

                </div>
              </div>
            </div>

            <div className="col-md-4 mt-2">
              <div className="alert alert-secondary" role="alert">

                <img src={somanytiles} className="card-img-top" alt="somanytiles_karimpur" />
                <div className="card-body">
                  <h5 className="card-title mt-2 mb-0">Somany Tiles</h5>
                  <p className="card-text mb-2">Best Somany tiles products avaialbe

                  </p>
                  <a style={{ color: "white" }} href="Somany" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                  </svg></a>

                </div>
              </div>
            </div>


            <div className="col-md-4 mt-2">
              <div className="alert alert-danger" role="alert">

                <img src={orintbelltiles} className="card-img-top" alt="orintbelltiles_karimpur" />
                <div className="card-body">
                  <h5 className="card-title mt-2 mb-0">Orintbell Tiles</h5>
                  <p className="card-text mb-2">Best Orintbell tiles products avaialbe

                  </p>
                  <a style={{ color: "white" }} href="Orientbell" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                  </svg></a>

                </div>
              </div>
            </div>

            <div className="col-md-4 mt-2">
              <div className="alert alert-warning" role="alert">

                <img src={dulux} className="card-img-top" alt="dulux_karimpur" />
                <div className="card-body">
                  <h5 className="card-title mt-2 mb-0">Dulux</h5>
                  <p className="card-text mb-2">Best dulux products avaialbe

                  </p>
                  <a style={{ color: "white" }} href="Dulux" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                  </svg></a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <br />

      <div className="album py-0">

        <div className="container">
          <h1><b>Jaquar</b></h1>
        </div>
      </div>
      <Jaquarpage />
      <Popup/>
      <br />




      <br />


      <div className="album py-0">
        <div className="container">

          <h1 className='mb-0'><b><b style={{ color: "#001284ff" }}>Kajaria</b> Nouvelle</b></h1>
          <p className='mb-0'><small> 600x1200mm, Unveiling the futuristic collection </small></p>
        </div>
      </div>
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">

                  <div className="card">
                    <Zoom>
                      <img src={alexus} className="card-img-top" alt="alexus" />
                    </Zoom>
                    <div className="card-body">
                      <h5 style={{ color: "black" }} className="card-title mb-1">Alexus Bianca</h5>
                      <p className="card-text">600x1200mm</p>


                      <div className="d-flex justify-content-between align-items-center mb-0">
                        <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-md-6  mt-3">

                  <div className="card">
                    <Zoom>
                      <img src={bannet} className="card-img-top" alt="bannet" />
                    </Zoom>
                    <div className="card-body">
                      <h5 style={{ color: "black" }} className="card-title mb-1">Bennet Marble </h5>
                      <p className="card-text">600x1200mm</p>
                      <div className="d-flex justify-content-between align-items-center mb-0">
                        <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">

                  <div className="card">
                    <Zoom>
                      <img src={barndonpearl} className="card-img-top" alt="barndonpearl" />
                    </Zoom>
                    <div className="card-body">
                      <h5 className="card-title mb-1">Barndon Pearl</h5>
                      <p className="card-text">600x1200mm</p>
                      <div className="d-flex justify-content-between align-items-center mb-0">
                        <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6  mt-3">

                  <div className="card">
                    <Zoom>
                      <img src={Lucasmarble} className="card-img-top" alt="Lucasmarble" />
                    </Zoom>
                    <div className="card-body">
                      <h5 className="card-title mb-1" >Lucas Marble                    </h5>
                      <p className="card-text">600x1200mm</p>
                      <div className="d-flex justify-content-between align-items-center mb-0">
                        <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">

                  <div className="card">
                    <Zoom>
                      <img src={milangrey} className="card-img-top" alt="alexumilangrey" />
                    </Zoom>
                    <div className="card-body">
                      <h5 style={{ color: "black" }} className="card-title mb-1">Milan Grey</h5>
                      <p className="card-text">600x1200mm</p>


                      <div className="d-flex justify-content-between align-items-center mb-0">
                        <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-md-6  mt-3">

                  <div className="card">
                    <Zoom>
                      <img src={elorawhite} className="card-img-top" alt="elorawhite" />
                    </Zoom>
                    <div className="card-body">
                      <h5 style={{ color: "black" }} className="card-title mb-1">Elora White </h5>
                      <p className="card-text">600x1200mm</p>
                      <div className="d-flex justify-content-between align-items-center mb-0">
                        <a style={{ color: "#ffffffff" }} className='Callbutton me-2' href='tel: 9932338173'> Call Now</a>


                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">

                  <div className="card">
                    <Zoom>
                      <img src={brellastone} className="card-img-top" alt="brellastone" />
                    </Zoom>
                    <div className="card-body">
                      <h5 className="card-title mb-1">Brella Stone</h5>
                      <p className="card-text">600x1200mm</p>
                      <div className="d-flex justify-content-between align-items-center mb-0">
                        <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6  mt-3">

                  <div className="card">
                    <Zoom>
                      <img src={Ordinagris} className="card-img-top" alt="Ordinagrish" />
                    </Zoom>
                    <div className="card-body">
                      <h5 className="card-title mb-1" >Ordina Gris                  </h5>
                      <p className="card-text">600x1200mm</p>
                      <div className="d-flex justify-content-between align-items-center mb-0">
                        <a className='Callbutton me-2' style={{ color: "#ffffffff" }} href='tel: 9932338173'> Call Now</a>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end align-items-end mb-0">
                <a href='KajariaNouvella60X120cm'>
                  <button className='marbelshowroomkarimpur mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                  </svg></button>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>




      <div className="album py-0">
        <div className="container">

          <h1 className='mb-0'><b><b style={{ color: "#001284ff" }}>Kajaria</b> Nouvelle</b></h1>
          <p className='mb-0'><small> 80X160cm, Unveiling the futuristic collection </small></p>
        </div>
      </div>
      <KajariaNouvella />


      <div className='facebook'>
        <br />
        <div className="album py-0">
          <div className="container">
            <h2><b>Facebook Page <a href='https://www.facebook.com/umahardwarekarimpur'>Uma Hardware</a></b></h2>
          </div>
        </div>
        <div className="album py-0">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mt-3">
                <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fumahardwarekarimpur&tabs=timeline&width=1000&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="100%" height="500" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
              </div>
              <div className="col-md-6 mt-3">
                <iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fumahardwarekarimpur%2Fvideos%2F1281469496604323%2F&show_text=true&width=560&t=0" width="100%" height="500" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>

              </div>
            </div>
          </div>
        </div>
        <br />
      </div>


      {/* 
      <div className="album py-2">
        <div className="container">

          <div className="row">

            <div className="col-md-6" >

              <div className="d-flex justify-content-between align-items-center">
                <div className="card mb-4 me-3 border-dark box">
                  <div className="a2zservice">
                    <Link to="/Kajaria">
                      <img src={Kajriacatlogue} className="card-img-top" alt="essco_Catlogue" /></Link>
                    <div class="card-body">
                      <div className="d-flex justify-content-between align-items-center">
                        <p style={{ color: "DarkSlateBlue		" }} className="card-text mb-2"><b>Kajaria</b></p>
                        <Link to="/">

                        </Link>

                      
                        <button type="button" className="btn btn-dark btn-sm mb-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                          Share <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-share-fill" viewBox="0 0 16 16">
                            <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                          </svg>
                        </button>

                      
                        <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Share Now </h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div className="modal-body">
                                < FacebookShareButton url="/https://www.umahardware.in/Kajaria" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                                >
                                  <FacebookIcon size={37} round={true} />
                                </FacebookShareButton>

                                <  WhatsappShareButton url="/https://www.umahardware.in/Kajaria" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                                >
                                  <WhatsappIcon size={37} round={true} />
                                </ WhatsappShareButton>

                                <  TwitterShareButton url="/https://www.umahardware.in/Kajaria" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                                >
                                  <TwitterIcon size={37} round={true} />
                                </ TwitterShareButton>

                                <  LinkedinShareButton url="/https://www.umahardware.in/Kajaria" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                                >

                                  <  LinkedinIcon size={37} round={true} />
                                </ LinkedinShareButton>

                                <  EmailShareButton url="/https://www.umahardware.in/Kajaria" quote={"Uma Hardware"} hastag={"#WebApp"}
                                >
                                  <  EmailIcon size={37} round={true} />
                                </ EmailShareButton>
                              </div>
                              <div className="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <center>
                      <h5 style={{ color: "Gray" }} className="card-title mb-2">UMA HARDWARE</h5>




                      <a href='Kajaria'>
                        <button type="button" class="no1tileskarimpur btn-sm mb-2"><small> Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></small> </button><br />
                      </a>
                      <a href={kajariavitronite2025} style={{ color: "white" }} className="jaquar mb-2" target="_blank" rel="noopener noreferrer">Download Catalogue</a>
                    </center>
                  </div>


                </div>
                <div className="card mb-4 me-2 border-dark box shadow">
                  <a href='Johnson' >
                    <img src={Johnson} className="card-img-top" alt="CatloguePhinolex" /></a>
                  <div class="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <p style={{ color: "DarkSlateBlue		" }} className="card-text mb-2">Johnson</p>


                
                      <button type="button" className="btn btn-dark btn-sm mb-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        <small> Share </small> <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" className="bi bi-share-fill" viewBox="0 0 16 16">
                          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                        </svg>
                      </button>

                 
                      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalLabel"> Share Now </h5>
                              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                              < FacebookShareButton url="/https://www.umahardware.in/Johnson" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <FacebookIcon size={37} round={true} />
                              </FacebookShareButton>

                              <  WhatsappShareButton url="/https://www.umahardware.in/Johnson" className="me-2" quote={"Fashion World Ladies Beauty Parlour"} hastag={"#WebApp"}
                              >
                                <WhatsappIcon size={37} round={true} />
                              </ WhatsappShareButton>

                              <  TwitterShareButton url="/https://www.umahardware.in/Johnson" className="me-2" quote={"Fashion World Ladies Beauty Parlour"} hastag={"#WebApp"}
                              >
                                <TwitterIcon size={37} round={true} />
                              </ TwitterShareButton>

                              <  LinkedinShareButton url="/https://www.umahardware.in/Johnson" className="me-2" quote={"Fashion World Ladies Beauty Parlour"} hastag={"#WebApp"}
                              >

                                <  LinkedinIcon size={37} round={true} />
                              </ LinkedinShareButton>

                              <  EmailShareButton url="/https://www.umahardware.in/Johnson" quote={"Fashion World Ladies Beauty Parlour"} hastag={"#WebApp"}
                              >
                                <  EmailIcon size={37} round={true} />
                              </ EmailShareButton>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <center>
                    <h5 style={{ color: "Gray" }} className="card-title">UMA HARDWARE</h5>

                    <a href='Johnson'>
                      <button type="button" class="no1tileskarimpur btn-sm mb-2"><small> Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></small> </button><br />
                    </a>
                    <a href={PdfJohnson} style={{ color: "white" }} className="jaquar mb-2" target="_blank" rel="noopener noreferrer">Download Catalogue</a>
                  </center>
                </div>


              </div>

              <div className="d-flex justify-content-between align-items-center">
                <div className="card mb-4 me-3 border-dark box shadow">
                  <Link to="/Orientbell">
                    <img src={Orientbellcatlogue} className="card-img-top" alt="cotobathware_catalogue" /></Link>
                  <div class="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <p style={{ color: "DarkSlateBlue		" }} className="card-text mb-2"><small>Orientbell</small></p>
                      <Link to="/">

                      </Link>

                      <button type="button" className="btn btn-dark btn-sm mb-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Share <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-share-fill" viewBox="0 0 16 16">
                          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                        </svg>
                      </button>

                 
                      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalLabel">Share Now </h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                              < FacebookShareButton url="/https://www.umahardware.in/Orientbell" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <FacebookIcon size={37} round={true} />
                              </FacebookShareButton>

                              <  WhatsappShareButton url="/https://www.umahardware.in/Orientbell" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <WhatsappIcon size={37} round={true} />
                              </ WhatsappShareButton>

                              <  TwitterShareButton url="/https://www.umahardware.in/Orientbell" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <TwitterIcon size={37} round={true} />
                              </ TwitterShareButton>

                              <  LinkedinShareButton url="/https://www.umahardware.in/Orientbell" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >

                                <  LinkedinIcon size={37} round={true} />
                              </ LinkedinShareButton>

                              <  EmailShareButton url="/https://www.umahardware.in/Orientbell" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <  EmailIcon size={37} round={true} />
                              </ EmailShareButton>
                            </div>
                            <div className="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <center>
                    <h5 style={{ color: "Gray" }} className="card-title">UMA HARDWARE</h5>
                    <a href='Orientbell'>
                      <button type="button" class="btn btn-outline-primary btn-sm mb-2"><small> ক্লিক করুন</small> </button><br />
                    </a>
                    <a href={Pdforientbellcatalogue} className="btn btn-outline-dark btn-sm mb-2" >Download Catalogue</a>
                  </center>
                </div>



                <div className="card mb-4 me-0 border-dark box shadow">
                  <a href='coto' >
                    <img src={cotobathware} className="card-img-top" alt="Coto" /></a>
                  <div class="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <p style={{ color: "DarkSlateBlue		" }} className="card-text mb-2"><b>Coto</b></p>


                 
                      <button type="button" className="btn btn-dark btn-sm mb-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Share <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-share-fill" viewBox="0 0 16 16">
                          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                        </svg>
                      </button>

                 
                      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalLabel">Share Now </h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                              < FacebookShareButton url="/https://www.umahardware.in/Coto" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <FacebookIcon size={37} round={true} />
                              </FacebookShareButton>

                              <  WhatsappShareButton url="/https://www.umahardware.in/Coto" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <WhatsappIcon size={37} round={true} />
                              </ WhatsappShareButton>

                              <  TwitterShareButton url="/https://www.umahardware.in/Coto" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <TwitterIcon size={37} round={true} />
                              </ TwitterShareButton>

                              <  LinkedinShareButton url="/https://www.umahardware.in/Coto" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >

                                <  LinkedinIcon size={37} round={true} />
                              </ LinkedinShareButton>

                              <  EmailShareButton url="/https://www.umahardware.in/Coto" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <  EmailIcon size={37} round={true} />
                              </ EmailShareButton>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <center>
                    <h5 style={{ color: "Gray" }} className="card-title">UMA HARDWARE</h5>
                    <a href='coto'>
                      <button type="button" class="btn btn-outline-primary btn-sm mb-2"><small> ক্লিক করুন</small> </button><br />
                    </a>
                    <a href={PdfCoto} className="btn btn-outline-dark btn-sm mb-2" >Download Catalogue</a>


                  </center>

                </div>
              </div>
            </div>




            <div className="col-md-6">
              <div className="d-flex justify-content-between align-items-center">
                <div className="card mb-4 me-3 border-dark box ">
                  <Link to="/Jaquar">
                    <img src={Jaqure} className="card-img-top" alt="Jaqure_catlogue" /></Link>
                  <div class="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <p style={{ color: "DarkSlateBlue		" }} className="card-text mb-2"><b>Jaqure</b></p>
                      <Link to="/">

                      </Link>

               
                      <button type="button" className="btn btn-dark btn-sm mb-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Share <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-share-fill" viewBox="0 0 16 16">
                          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                        </svg>
                      </button>

              
                      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalLabel">Share Now </h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                              < FacebookShareButton url="/https://www.umahardware.in/Jaquar" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <FacebookIcon size={37} round={true} />
                              </FacebookShareButton>

                              <  WhatsappShareButton url="/https://www.umahardware.in/Jaquar" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <WhatsappIcon size={37} round={true} />
                              </ WhatsappShareButton>

                              <  TwitterShareButton url="/https://www.umahardware.in/Jaquar" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <TwitterIcon size={37} round={true} />
                              </ TwitterShareButton>

                              <  LinkedinShareButton url="/https://www.umahardware.in/Jaquar" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >

                                <  LinkedinIcon size={37} round={true} />
                              </ LinkedinShareButton>

                              <  EmailShareButton url="/https://www.umahardware.in/Jaquar" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <  EmailIcon size={37} round={true} />
                              </ EmailShareButton>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <center>
                    <h5 style={{ color: "Gray" }} className="card-title">UMA HARDWARE</h5>
                    <a href='Jaquar'>
                      <button type="button" class="no1tileskarimpur btn-sm mb-2"><small> Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></small> </button><br />
                    </a>
                    <a href={PdfJaquar} style={{ color: "white" }} className="jaquar mb-2" target="_blank" rel="noopener noreferrer">Download Catalogue</a>
                  </center>

                </div>
                <div className="card mb-4 border-dark box shadow">
                  <Link to="/Somany">
                    <img src={Somanycatlogue} className="card-img-top" alt="Somanycatlogue" /></Link>
                  <div class="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <Link to="/Somany">
                        <p style={{ color: "DarkSlateBlue		" }} className="card-text mb-2">Somany</p></Link>
                      <Link to="/">

                      </Link>

           
                      <button type="button" className="btn btn-dark btn-sm mb-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Share <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-share-fill" viewBox="0 0 16 16">
                          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                        </svg>
                      </button>

                     
                      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalLabel">Share Now </h5>
                              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                              < FacebookShareButton url="/https://www.umahardware.in/Somany" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <FacebookIcon size={37} round={true} />
                              </FacebookShareButton>

                              <  WhatsappShareButton url="/https://www.umahardware.in/Somany" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <WhatsappIcon size={37} round={true} />
                              </ WhatsappShareButton>

                              <  TwitterShareButton url="/https://www.umahardware.in/Somany" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <TwitterIcon size={37} round={true} />
                              </ TwitterShareButton>

                              <  LinkedinShareButton url="/https://www.umahardware.in/Somany" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >

                                <  LinkedinIcon size={37} round={true} />
                              </ LinkedinShareButton>

                              <  EmailShareButton url="/https://www.umahardware.in/Somany" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <  EmailIcon size={37} round={true} />
                              </ EmailShareButton>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <center>
                    <h5 style={{ color: "Gray" }} className="card-title">UMA HARDWARE</h5>
                    <Link to="/Somany">
                      <button type="button" class="btn btn-outline-primary btn-sm mb-2"><small> ক্লিক করুন</small> </button><br />
                    </Link>
                    <a href={SOMANYPDFH} className="btn btn-outline-dark btn-sm mb-2" >Download Catalogue</a>
                  </center>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="card mb-4 me-3 border-dark box shadow">
                  <Link to="/Dulux">
                    <img src={Dulux} className="card-img-top" alt="Dulux" /></Link>

                  <div class="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <p style={{ color: "DarkSlateBlue		" }} className="card-text mb-2"><b>Dulux</b></p>
                      <Link to="/">

                      </Link>

         
                      <button type="button" className="btn btn-dark btn-sm mb-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Share <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-share-fill" viewBox="0 0 16 16">
                          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                        </svg>
                      </button>

                
                      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalLabel">Share Now </h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                              < FacebookShareButton url="/https://www.umahardware.in/Dulux" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <FacebookIcon size={37} round={true} />
                              </FacebookShareButton>

                              <  WhatsappShareButton url="/https://www.umahardware.in/Dulux" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <WhatsappIcon size={37} round={true} />
                              </ WhatsappShareButton>

                              <  TwitterShareButton url="/https://www.umahardware.in/Dulux" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <TwitterIcon size={37} round={true} />
                              </ TwitterShareButton>

                              <  LinkedinShareButton url="/https://www.umahardware.in/Dulux" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >

                                <  LinkedinIcon size={37} round={true} />
                              </ LinkedinShareButton>

                              <  EmailShareButton url="/https://www.umahardware.in/Dulux" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <  EmailIcon size={37} round={true} />
                              </ EmailShareButton>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <center>
                    <h5 style={{ color: "Gray" }} className="card-title">UMA HARDWARE</h5>
                    <Link to="/Dulux">
                      <button type="button" class="btn btn-outline-primary btn-sm mb-2"><small> ক্লিক করুন</small> </button><br />
                    </Link>
                    <button className="btn btn-dark btn-sm mb-2">Watch Video</button>
                  </center>
                </div>
                <div className="card mb-4 me-0 border-dark box shadow">
                  <Link to="/Finolex">
                    <img src={CatloguePhinolex} className="card-img-top" alt="Finolex" /></Link>
                  <div class="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <p style={{ color: "DarkSlateBlue		" }} className="card-text mb-2">Finolex</p>
                      <Link to="/">

                      </Link>

                     
                      <button type="button" className="btn btn-dark btn-sm mb-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Share <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-share-fill" viewBox="0 0 16 16">
                          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                        </svg>
                      </button>

                      
                      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="exampleModalLabel">Share Now </h5>
                              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                              < FacebookShareButton url="/https://www.umahardware.in/Finolex" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <FacebookIcon size={37} round={true} />
                              </FacebookShareButton>

                              <  WhatsappShareButton url="/https://www.umahardware.in/Finolex" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <WhatsappIcon size={37} round={true} />
                              </ WhatsappShareButton>

                              <  TwitterShareButton url="/https://www.umahardware.in/Finolex" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <TwitterIcon size={37} round={true} />
                              </ TwitterShareButton>

                              <  LinkedinShareButton url="/https://www.umahardware.in/Finolex" className="me-2" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >

                                <  LinkedinIcon size={37} round={true} />
                              </ LinkedinShareButton>

                              <  EmailShareButton url="/https://www.umahardware.in/Finolex" quote={"Uma Hardware"} hastag={"#WebApp"}
                              >
                                <  EmailIcon size={37} round={true} />
                              </ EmailShareButton>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <center>
                    <h5 style={{ color: "Gray" }} className="card-title">UMA HARDWARE</h5>
                    <Link to="/Finolex">
                      <button type="button" class="btn btn-outline-primary btn-sm mb-2"><small> ক্লিক করুন</small> </button><br />
                    </Link>
                    <a href={Pdffinoloex} className="btn btn-outline-dark btn-sm mb-2" >Download Catalogue</a>
                  </center>
                </div>
              </div>





              <br />
              <div className="d-flex justify-content-between align-items-center">


              </div>

            </div>

          </div>
        </div>
      </div>

      <div className="album py-0">

        <div className="container">
          <h2 style={{ color: "#040273" }}><b>Water Tec</b></h2>
        </div>
      </div> */}

      <div className="umahardwarebg">
        <div className="album py-0">

          <div className="container">

            <div className="row">
              <div className="col-md-4" >

                <br />
                <div className="card mb-4 me-0 border-white box shadow">
                  <ReactPlayer width='354px' height='420px' url="https://www.youtube.com/watch?v=lidmgWzL2yk" />

                </div>
              </div>
              <div className="col-md-4" >
                <br />
                <div className="card mb-4 me-0 border-white box shadow">
                  <ReactPlayer width='354px' height='420px' url="https://www.youtube.com/watch?v=SeM00wQc3hw" />

                </div>
              </div>
                 <div className="col-md-4" >
                <br />
                <div className="card mb-4 me-0 border-white box shadow">
                  <ReactPlayer width='354px' height='420px' url="https://www.youtube.com/watch?v=YZqnRjX1RDU" />

                </div>
              </div>
              <div className="col-md-4" >



                <br />
                <div className="card mb-4 me-0 border-white box shadow">
                  <ReactPlayer width='354px' height='420px' url="https://www.youtube.com/watch?v=rBqMAD_oUYg" />

                </div>


              </div>
              <div className="col-md-4" >



                <br />
                <div className="card mb-4 me-0 border-white box shadow">

                  <ReactPlayer width='354px' height='420px' url="https://www.youtube.com/watch?v=95G_JlwsjXI" />
                </div>
                {/* <div className="newa">
<button onClick={likef}  className={[likeactive ? 'active-like' :null,'button'].join('')}>Like{like}</button>
<button onClick={dislikef} className={[dislikeactive? "active-dislike" :null,"button"].join("")}>Dislike {dislike}</button>
</div> */}

              </div>
              {/* style={{textAlign: "center"}} */}
              <div className="col-md-4" >

                <br />
                <div className="card mb-4 me-0 border-white box shadow">
                  <ReactPlayer width='354px' height='420px' url="https://www.youtube.com/watch?v=tJB70mLU9rU" />
                </div>

              </div>
              <div className="col-md-4" >

                <br />
                <div className="card mb-4 me-0 border-white box shadow">
                  <ReactPlayer width='354px' height='420px' url="https://www.youtube.com/watch?v=iOn0Yp6hNqg" />

                </div>
              </div>
              <div className="col-md-4" >

                <br />
                <div className="card mb-4 me-0 border-white box shadow">
                  <ReactPlayer width='354px' height='420px' url="https://www.youtube.com/watch?v=Fj8j5gon4o4" />
                </div>

              </div>
              <div className="col-md-4" >

                <br />
                <div className="card mb-4 me-0 border-white box shadow">
                  <ReactPlayer width='354px' height='420px' url="https://www.youtube.com/watch?v=HAjcnS9raVs" />
                </div>

              </div>

            </div>

          </div>
        </div>
        <br />
        <hr />
      </div>

      <div className="album py-0">

        <div className="container">
          <h1><b>Orientbell Tiles</b></h1>
        </div>
      </div>
      <Orient />

      <hr />
      <div className="album py-0">

        <div className="container">
          <h1><b>Somany Verified Tiles</b></h1>
        </div>
      </div>
      <Somany />
      <hr />


      <Umamap />

    </div>
  )
}

export default Home
